// Contenus des pages légales — champs entre crochets [] = à compléter avant mise en production.
export const LEGAL_CONTENT = {
    fr: {
        mentions: {
            eyebrow: "Informations légales",
            title: "Mentions légales",
            updated: "Dernière mise à jour : juillet 2026",
            back: "Retour à l'accueil",
            sections: [
                {
                    heading: "Éditeur du site",
                    paragraphs: [
                        "WEYB — Cabinet d'accompagnement au développement international.",
                        "Siège : 96 Rue Paradis, 13006 Marseille, France.",
                        "Filiale : 62 bis, AV UMA, Imm Nessma, B27, 2080 Tunis, Tunisie.",
                        "Email : contact@weyb.fr — Tél. : +33 6 05 58 09 77.",
                        "Directeur de la publication : Saber Bellaaj, Fondateur & CEO.",
                        "Forme juridique : SAS (société par actions simplifiée) — SIREN 927 974 550 — SIRET 927 974 550 00018 — RCS Marseille — Code APE 62.02A (conseil en systèmes et logiciels informatiques).",
                        "Capital social : 1 000 €.",
                    ],
                },
                {
                    heading: "Hébergement",
                    paragraphs: [
                        "[À compléter lors de la mise en production : nom et coordonnées de l'hébergeur du site.]",
                    ],
                },
                {
                    heading: "Propriété intellectuelle",
                    paragraphs: [
                        "L'ensemble des contenus du site (textes, identité visuelle, logo WEYB) est la propriété de WEYB, sauf mention contraire. Les logos des organisations présentés dans les sections « Expériences et collaborations » appartiennent à leurs détenteurs respectifs et sont utilisés avec leur accord.",
                        "Toute reproduction ou réutilisation sans autorisation écrite préalable est interdite.",
                    ],
                },
                {
                    heading: "Données personnelles",
                    paragraphs: [
                        "Le traitement des données personnelles collectées via ce site est décrit dans la Politique de confidentialité.",
                    ],
                },
            ],
        },
        confidentialite: {
            eyebrow: "Protection des données",
            title: "Politique de confidentialité",
            updated: "Dernière mise à jour : juillet 2026",
            back: "Retour à l'accueil",
            sections: [
                {
                    heading: "Responsable de traitement",
                    paragraphs: [
                        "WEYB — 96 Rue Paradis, 13006 Marseille, France — contact@weyb.fr.",
                    ],
                },
                {
                    heading: "Données collectées",
                    paragraphs: [
                        "Via le formulaire de contact : prénom, nom, entreprise, email professionnel, pays, besoin exprimé et message.",
                        "Finalité : répondre à votre demande et échanger sur votre projet. Base légale : mesures précontractuelles (article 6.1.b du RGPD).",
                        "Conservation : 24 mois maximum. Aucune donnée n'est cédée ni vendue à des tiers.",
                    ],
                },
                {
                    heading: "Cookies et mesure d'audience",
                    paragraphs: [
                        "Avec votre consentement, ce site utilise Google Analytics (Google Ireland Ltd) pour mesurer l'audience : pages vues, durée de visite et provenance du trafic, de manière pseudonymisée.",
                        "Aucun cookie analytique n'est déposé sans votre accord : le bandeau affiché lors de votre première visite vous permet d'accepter ou de refuser. Votre choix est conservé 6 mois et peut être modifié à tout moment via le lien « Préférences cookies » en bas de page.",
                    ],
                },
                {
                    heading: "Vos droits",
                    paragraphs: [
                        "Vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité concernant vos données. Pour les exercer : contact@weyb.fr.",
                        "Vous pouvez également adresser une réclamation à la CNIL (cnil.fr).",
                    ],
                },
            ],
        },
    },
    en: {
        mentions: {
            eyebrow: "Legal information",
            title: "Legal notice",
            updated: "Last updated: July 2026",
            back: "Back to homepage",
            sections: [
                {
                    heading: "Site publisher",
                    paragraphs: [
                        "WEYB — International business development consultancy.",
                        "Head office: 96 Rue Paradis, 13006 Marseille, France.",
                        "Subsidiary: 62 bis, AV UMA, Imm Nessma, B27, 2080 Tunis, Tunisia.",
                        "Email: contact@weyb.fr — Phone: +33 6 05 58 09 77.",
                        "Publication director: Saber Bellaaj, Founder & CEO.",
                        "Legal form: SAS (simplified joint-stock company) — SIREN 927 974 550 — SIRET 927 974 550 00018 — Marseille Trade and Companies Register (RCS) — APE code 62.02A (IT systems and software consulting).",
                        "Share capital: €1,000.",
                    ],
                },
                {
                    heading: "Hosting",
                    paragraphs: [
                        "[To be completed at go-live: hosting provider name and contact details.]",
                    ],
                },
                {
                    heading: "Intellectual property",
                    paragraphs: [
                        "All site content (text, visual identity, WEYB logo) is the property of WEYB unless stated otherwise. Logos of organisations shown in the “Experience and collaborations” sections belong to their respective owners and are used with their consent.",
                        "Any reproduction or reuse without prior written authorisation is prohibited.",
                    ],
                },
                {
                    heading: "Personal data",
                    paragraphs: [
                        "The processing of personal data collected via this site is described in the Privacy policy.",
                    ],
                },
            ],
        },
        confidentialite: {
            eyebrow: "Data protection",
            title: "Privacy policy",
            updated: "Last updated: July 2026",
            back: "Back to homepage",
            sections: [
                {
                    heading: "Data controller",
                    paragraphs: [
                        "WEYB — 96 Rue Paradis, 13006 Marseille, France — contact@weyb.fr.",
                    ],
                },
                {
                    heading: "Data collected",
                    paragraphs: [
                        "Via the contact form: first name, last name, company, professional email, country, expressed need and message.",
                        "Purpose: responding to your enquiry and discussing your project. Legal basis: pre-contractual measures (GDPR article 6.1.b).",
                        "Retention: 24 months maximum. No data is shared with or sold to third parties.",
                    ],
                },
                {
                    heading: "Cookies and analytics",
                    paragraphs: [
                        "With your consent, this site uses Google Analytics (Google Ireland Ltd) to measure audience: pages viewed, visit duration and traffic sources, in a pseudonymised way.",
                        "No analytics cookie is set without your agreement: the banner shown on your first visit lets you accept or refuse. Your choice is kept for 6 months and can be changed anytime via the “Cookie preferences” link in the page footer.",
                    ],
                },
                {
                    heading: "Your rights",
                    paragraphs: [
                        "You have the right to access, rectify, erase, object to and port your data. To exercise these rights: contact@weyb.fr.",
                        "You may also lodge a complaint with the CNIL (cnil.fr).",
                    ],
                },
            ],
        },
    },
};
